import { ChangeDetectorRef, Component, OnDestroy, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { RaciService } from '../../../modules/raci/services/raci.service';
import { ArgusIntegrationService } from '../../../services/ArgusIntegrationService';
import { ProjectValuationTabs } from '../../enum';
import { NavigationActionBase } from '../../navigation-action-base';
import { NavigationService } from '../../navigation.service';
import { EventBusService } from '../../../services/event-bus.service';
import { AppStorageService } from '../../../services/app-storage.service';
import { RaciNavigationService } from '../../raci-navigation.service';
/**
 * Valuation portofolio navigation component
 */
@Component({
  selector: 'valuation-portofolio-navigation',
  templateUrl: './valuation-portofolio-navigation.component.html'
})
export class ValuationPortofolioNavigationComponent extends NavigationActionBase implements OnInit, OnDestroy {
  /**
   * Search tab visibility
   */
  @Input() searchTabVisible: boolean;
  /**
   * Change detector reference
   */
  private _ref: ChangeDetectorRef;
  /**
   * Navigation service
   */
  private _navigationService: NavigationService;
  /**
   * Argus integration service
   */
  private _argusIntegrationService: ArgusIntegrationService;
  /**
   * Raci service
   */
  private _raciService: RaciService;

  /**
   * Raci navigation service
   */
  private _raciNavigationService: RaciNavigationService;
  /**
   * Show finalize button
   */
  public showFinalizeButton = false;
  /**
   * Show import flatfile button
   */
  public showImportFlatfile = false;
  /**
   * Display client dashboard action
   */
  displayClientDashboardAction = false;
  /**
   * Portfolio selected
   */
  portfolioSelected = false;
  /**
   * Display publish button
   */
  displayPublishButton = false;
  /**
   * Display import actions
   */
  displayImportActions = false;
  /**
   * Enable next import action
   */
  enableNextImportAction = false;
  /**
   * Report publish enabled
   */
  reportPublishEnabled = environment.reportPublishEnabled;
  /**
   * Is child event
   */
  isChildEvent = false;
  /**
   * Infobar visibility
   */
  infobarVisible = false;
  /**
   * Active infobar
   */
  activeInfobar = '';
  /**
   * Available currencies
   */
  availableCurrencies = 0;
  /**
   * Search mode
   */
  searchMode = 'valuationPortfolio';
  /**
   * Selected tab
   */
  selectedTab: ProjectValuationTabs = ProjectValuationTabs.Projects;
  /**
   * Portfolio ids
   */
  portfolioIds: any;
  /**
   * Portfolio properties number
   */
  portfolioPropertiesNumber: any;
  /**
   * Toggle organization
   */
  toggleOrganization = false;
  /**
   * Toggle data
   */
  toggleData = false;
  /**
   * Grouping item selected
   */
  groupingItemSelected = null;
  /**
   * Already exported portfolios
   */
  alreadyExportedPortfolios: any;
  /**
   * Should export to argus
   */
  shouldExportToArgus = false;
  /**
   * Dont have participants
   */
  dontHaveParticipants = true;
  /**
   * Argus dialog processed
   */
  argusDialogProcessed = "";
  /**
   * Show steps
   */
  showSteps = false;
  /**
   * Can add new currency
   */
  get canAddNewCurrency() {
    return this.infobarVisible && this.activeInfobar === 'currencies' && this.availableCurrencies > 0;
  }
  /**
   * Constructor
   * @param ref
   * @param navigationService
   * @param argusIntegrationService
   * @param raciService
   */
  constructor(eventBus: EventBusService,
    appStorage: AppStorageService,
    ref: ChangeDetectorRef,
    navigationService: NavigationService,
    argusIntegrationService: ArgusIntegrationService,
    raciService: RaciService,
    raciNavigationService: RaciNavigationService) {
    super(appStorage, eventBus, ref, navigationService);
    this._ref = ref;
    this._navigationService = navigationService;
    this._argusIntegrationService = argusIntegrationService;
    this._raciService = raciService;
    this._raciNavigationService = raciNavigationService;
  }
  /**
   * NgOnInit
   */
  ngOnInit(): void {
    super.ngOnInit();
    this.subscribeToActiveTab();
    this.showClientDashboardAction();
    this._navigationService.setActiveValuationEventPropertiesGrouping(1);//default "by country"
    this._navigationService.setActiveValuationEventParticipantsGrouping(1);
    this._navigationService.setActiveValuationEventCurrenciesGrouping(1);
    this.isValuationEventSelected();

    this.onEvents.push(
      this.eventBus.subscribeEvent('appStorage:setSelectedPortfolio', (portfolio) => {
        setTimeout(() => {
          this.portfolioSelected = portfolio != null;
          this.isChildEvent = portfolio?.ParentId > 0;
          this.showFinalizeButton = this.portfolioSelected && !portfolio.isFinalized;
          this.showImportFlatfile = this.portfolioSelected && !portfolio.isFinalized;
          this.displayPublishButton = this.portfolioSelected && !portfolio.ClientDashboardPublished;
          this.displayClientDashboardAction = this.portfolioSelected && portfolio.ClientDashboardPublished;
          this.eventBus.broadcastEvent('getAllSelectedPortfolios');
          if (this.portfolioSelected) {
            setTimeout(() => {
              this.subscriptions.add(this._raciService.getParticipants(true, null, portfolio.ProjectID).pipe(take(1)).subscribe(data => {
                this.dontHaveParticipants = data.length <= 0;
              }));
              this.subscriptions.add(this._raciService.getPortfolioProperties(portfolio.Oid).subscribe(data => {
                this.showSteps = !this.dontHaveParticipants && data.length > 0;
                this._ref.markForCheck();
              }))
            })
          }
          this._ref.markForCheck();
        });
      })
    );

    this._raciNavigationService._updateStepsIcon.subscribe(data => {
      if (data) {
        this.subscriptions.add(this._raciService.getPortfolioProperties(this.appStorage.getSelectedPortfolio().Oid).subscribe(response => {
          this.showSteps = response.length > 0;
          this._ref.markForCheck();
        }))
      }
    });

    this.onEvents.push(
      this.eventBus.subscribeEvent('hideImportNavigationActions', () => {
        setTimeout(() => {
          this.displayImportActions = false;
          this._ref.markForCheck();
        });
      })
    );

    this.onEvents.push(
      this.eventBus.subscribeEvent('hideImportNavigationActions', () => {
        setTimeout(() => {
          this.displayImportActions = false;
          this._ref.markForCheck();
        });
      })
    );

    this.onEvents.push(
      this.eventBus.subscribeEvent('enableNextImportAction', (enabled) => {
        setTimeout(() => {
          this.enableNextImportAction = enabled;
          this._ref.markForCheck();
        });
      })
    );

    this.onEvents.push(
      this.eventBus.subscribeEvent('PVInfobarVisibilityChanged', (visible) => {
        setTimeout(() => {
          this.infobarVisible = visible;
          this._ref.markForCheck();
        });
      })
    );

    this.onEvents.push(
      this.eventBus.subscribeEvent('portfolio:CurrenciesManagementAvailableCurrencies', (count) => {
        setTimeout(() => {
          this.availableCurrencies = count;
          this._ref.markForCheck();
        });
      })
    );

    this.eventBus.broadcastEvent('request:appStorage:setSelectedPortfolio');
  }
  /**
   * Show client dashboard action
   */
  showClientDashboardAction() {
    this.onEvents.push(
      this.eventBus.subscribeEvent('ShowClientDashboardAction', (display) => {
        setTimeout(() => {
          this.displayClientDashboardAction = display;
          this._ref.markForCheck();
        })
      })
    );

    this.onEvents.push(
      this.eventBus.subscribeEvent('displayImportActions', (display) => {
        setTimeout(() => {
          this.displayImportActions = display;
          this._ref.markForCheck();
        })
      })
    );

    this.onEvents.push(
      this.eventBus.subscribeEvent('exportToArgusPortfolio', (allPortfolios) => {
        const selectedPortfoliosWithProperties = allPortfolios.filter(y => y.NumberOfPropertyCalc > 0);
        this.subscriptions.add(this._argusIntegrationService.createArgusPortfolio(selectedPortfoliosWithProperties).subscribe(serializedData => {
          const data = JSON.parse(serializedData);
          if (data) {
            this.argusDialogProcessed = "";

            data?.argusPortfolioMessages.forEach(message => {
              this.argusDialogProcessed += message;
            });

            this.argusDialogProcessed += ' <br/> ';

            data?.argusPropertyMessages.forEach(message => {
              this.argusDialogProcessed += message;
            });
            this.argusDialogProcessed += ' <br/> All actions completed. You can close this window. <br/>';
            this.eventBus.broadcastEvent('argusIntegrationCompleted');
            this.eventBus.broadcastEvent("argusDialog", {
              success: () => {
                //Nothing
              },
              cancel: () => {
                //Nothing
              },
              dialogContent: () => {
                return this.argusDialogProcessed
              },
              shouldShowCloseButton: () => {
                return true;
              }
            }, 'exportToArgusConfirmDialog');
          }
          else {
            this.eventBus.broadcastEvent('argusIntegrationCompleted');
          }
        }));
        this._ref.markForCheck();
      })
    )
  }
  /**
   * Cancel import
   */
  cancelImport() {
    this.triggerAction('onImportCancel');
    this.displayImportActions = false;
  }
  /**
   * Trigger next step for import
   */
  triggerNextStepForImport() {
    this.triggerAction('triggerNextStepForImport');
    this.enableNextImportAction = false;
    this._ref.markForCheck();
  }
  /**
   * Show portfolio currencies clicked
   * @param groupingType
   */
  showPortfolioCurrenciesClicked(groupingType: number) {
    this._navigationService.setActiveValuationEventCurrenciesGrouping(groupingType);

    if (!this.formOpened) {
      this.triggerAction('showCurrenciesPane');
    }
  }
  /**
   * Set info bar file attachment visibility
   */
  setInfoBarFileAttachmentVisibility() {
    this.activeInfobar = 'fileAttachmentsValuationPortfolio';
    this.toggleActiveInfobar({ infobarType: this.activeInfobar });
  }
  /**
   * Show portfolio properties clicked
   * @param groupingType
   */
  showPortfolioPropertiesClicked(groupingType: number) {
    this._navigationService.setActiveValuationEventPropertiesGrouping(groupingType);

    if (!this.formOpened) {
      this.triggerAction('showPortfolioProperties');
    }
  }
  /**
   * Show portfolio participants clicked
   * @param value
   */
  showPortfolioParticipantsClicked(value: number) {
    this._navigationService.setActiveValuationEventParticipantsGrouping(value);

    if (!this.formOpened) {
      this.triggerAction('showPortfolioParticipants');
    }
  }
  /**
   * Add new currency clicked
   */
  addNewCurrencyClicked() {
    this.eventBus.broadcastEvent(`portfolio:CurrenciesManagementAddNewRow`);
  }
  /**
   * Toggle active infobar
   * @param params
   */
  toggleActiveInfobar(params: any) {
    this.eventBus.broadcastEvent(`buttonTogglePVInfoModeClicked`, params);
  }
  /**
   * ngOnDestroy
   */
  ngOnDestroy() {
    super.ngOnDestroy();
  }
  /**
   * Subscribe to active tab
   */
  subscribeToActiveTab() {
    this.subscriptions.add(this._navigationService.activeProjectValuationTab$.subscribe(tab => {
      this.selectedTab = tab;
      if (this.searchTabVisible) {
        this.searchTabVisible = !this.searchTabVisible;
      }
      this._ref.markForCheck();
    }))
  }
  /**
   * Set search bar visibility
   */
  setSearchBarVisibility() {
    this.searchTabVisible = !this.searchTabVisible;
    this.eventBus.broadcastEvent('searchBarVisibility', this.searchTabVisible, this.searchMode);
  }
  /**
   * trigger alert action
   */
  triggerAlertAction() {
    alert("TODO Alert");
  }
  /**
   * Info message
   */
  infoMessage() {
    if (!this.showSteps) {
      alert('Please assign properties and participants to the project, before starting the process module');
    } else {
      this._raciService.displayDataLoader(true);
      this._raciNavigationService.onShowHideRaciModule(true);
    }
  }

  /**
   * Check if valuation event is selected on initialize
   * */
  isValuationEventSelected() {
    const portfolio = this.appStorage.getSelectedPortfolio();
    if (portfolio) {
      this.subscriptions.add(this._raciService.getParticipants(true, null, portfolio?.ProjectID).pipe(take(1)).subscribe(data => {
        this.dontHaveParticipants = data.length <= 0;
        this.showSteps = !this.dontHaveParticipants && portfolio.NumberOfPropertyCalc > 0;
        this._ref.markForCheck();
      }));
    }
  }

  /**
* Export portfolios to Excel
* */
  exportToExcel() {
    this.eventBus.broadcastEvent('exportToExcelPortfoliosGrid');
  }
}
